import styled from 'styled-components'

export const RecentLinkData = styled.div`
  font-size: 14px;
  color: #333;
  padding: 8px;
  margin-bottom: 3px;
  cursor: pointer;
`

export const RecentPostsWrapper = styled.div`
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  padding: 28px;
`

export const RecentPostsHeading = styled.h4`
  border-bottom: 0;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 15px;
`
export const RecentPostsLink = styled.div`
  text-decoration: none;
  color: #333;
`
